/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import moment from "moment-timezone";
import ComparasionTable from "./ComparisonTable";

const ModificationDetails = ({
    data,
    onChangeIndex,
}) => {

    const [dataIndex, setDataIndex] = useState(0);

    const countHistoryData = (obj) => {
        let count = 0;
        let current = obj;
        while (current?.previousData) {
            count++;
            current = current.previousData;
        }
        return count;
    };

    const hasHistory = (data) => {
        const count = countHistoryData(data);
        return { result: count > 0, count };
    };

    const getDataAtIndex = (obj, index) => {
        let current = obj;
        for (let i = 0; i < index; i++) {
            if (current?.previousData) current = current.previousData;
            else break;
        }
        return current;
    };

    const handleChangeIndex = (index) => {
        setDataIndex(index);
        if (onChangeIndex) onChangeIndex(getDataAtIndex(data, index));
    };

    const getRoleWording = (role, isDeferred) => {
        switch (role) {
            case "individual":
                return "Regular User";
            case "business":
                return isDeferred ? "Business User (Deferred)" : "Business User (Advanced)";
            default:
                return role;
        }
    }

    return (
        <>
            <h5 className={`tw:!font-hanken-grotesk tw:!mb-4 tw:!text-[15px] tw:!font-[600] tw:!text-[#282828]`}>
                <span className="tw:relative tw:inline-block">
                    <span className="tw:absolute tw:bottom-0 tw:left-0 tw:right-0 tw:h-[40%] tw:rounded-full tw:bg-[#F9EDD3]" />
                    <span className="tw:relative"> Modification Details</span>
                </span>
            </h5>
            <div className="border rounded mb-2">
                <div className="d-flex align-items-start gap-5 p-3">
                    <div className="d-flex flex-wrap" style={{ flex: 1, columnGap: '3rem', rowGap: '0.75rem' }}>
                        <div>
                            <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Modified/Requested On</p>
                            <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{moment.tz(data?.date, "Asia/Tokyo").locale("en").format("MMM D, YYYY H:mm")}</b>
                        </div>
                        <div>
                            <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Booking Created</p>
                            <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{moment.tz(data?.bookingId?.date, "Asia/Tokyo").locale("en").format("MMM D, YYYY H:mm")}</b>
                        </div>
                        <div>
                            <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">User Type</p>
                            <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{getRoleWording(data?.userId?.role, data?.userId?.deferredPaymentEligible)}</b>
                        </div>
                    </div>
                </div>
            </div>
            <div className="border rounded mb-3">
                {hasHistory(data).result && (
                    <div className="d-flex align-items-center gap-3 px-3 pt-3 pb-3">
                        <div className="flex-shrink-0">
                            <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[14px] tw:!font-[400] tw:!text-[#8D8D8D] tw:!whitespace-nowrap">Version History ({hasHistory(data).count + 1})</p>
                        </div>
                        <div style={{ flex: 1 }}>
                            <select
                                className="tw:!font-hanken-grotesk tw:w-full tw:rounded-[5px] tw:border tw:border-[#e8e8e8] tw:bg-white tw:px-3 tw:py-2 tw:text-[13px] tw:font-medium tw:text-[#282828] tw:outline-none focus:tw:border-[#D4B055]"
                                value={dataIndex}
                                onChange={(e) => handleChangeIndex(Number(e.target.value))}
                            >
                                {Array.from({ length: hasHistory(data).count + 1 }).map((_, index) => {
                                    const itemData = getDataAtIndex(data, index);
                                    return (
                                        <option key={index} value={index}>
                                            {index === 0 ? "Latest Request" : `Edit Request on ${moment.tz(itemData?.date, "Asia/Tokyo").locale("en").format("MMM D, YYYY")}`}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </div>
                )}

                <div className="d-flex align-items-start gap-5 p-0">
                    <ComparasionTable data={data} />
                </div>
            </div>
        </>
    );
};

export default ModificationDetails;
